<section class="tours">
  <div class="title">
    <h2>{{ title | translate }}</h2>
  </div>

  @if (!shuffle) {
    <div class="filter">
      <input [formControl]="formControl" placeholder="{{'Search' | translate}}" type="text"/>
    </div>
  }

  <div class="tours-grid">
    @for (tour of tours; track tour) {
      @let key = appStateService.selectedLanguage.key;

      @let route = key === LngKeys.EN ? '' : (key + '/');

      <a [routerLink]="'/' + route + 'tour/' + tour.urlKey">
        <app-tour-item [tour]="tour" class="tours-grid-item"/>
      </a>
    }
  </div>
</section>
